import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { WHATSAPP_LINK, TEL_LINK, AUTHOR } from "@/lib/site";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { Reveal } from "@/components/Reveal";

export const FinalCTA = () => {
    return (
        <section id="contato" className="relative py-24 md:py-32 lg:py-40 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0F] via-[#0E1326] to-[#0A0A0F]" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[800px] dg-glow" />
            <div className="absolute inset-0 dg-grid opacity-20" />

            <div className="relative max-w-3xl mx-auto px-6 md:px-12 text-center">
                <Reveal>
                    <div className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">
                        DEGASPERIN <span className="text-[#3B6FFF]">IA</span>
                    </div>
                    <div className="text-sm text-[#7A7A90] mt-1">{AUTHOR}</div>
                </Reveal>

                <Reveal delay={0.1}>
                    <p className="mt-8 text-sm font-semibold uppercase tracking-widest text-[#94B4FF]">
                        Seu próximo cliente não vai mais embora sem agendar.
                    </p>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F5F5F5] leading-tight">
                        Não acredita? Testa agora.
                    </h2>
                    <p className="mt-5 text-base lg:text-lg text-[#F5F5F5]/70 max-w-2xl mx-auto">
                        Chame no WhatsApp ou ligue. O agente atende, agenda e te manda a
                        confirmação. Você passa pela experiência completa.
                    </p>
                </Reveal>

                <Reveal delay={0.2}>
                    <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
                        <motion.a
                            data-testid="final-cta"
                            href={WHATSAPP_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.04 }}
                            whileTap={{ scale: 0.98 }}
                            className="inline-flex items-center justify-center gap-3 rounded-full bg-[#3B6FFF] px-8 py-4 text-lg font-bold text-white shadow-[0_0_45px_rgba(59,111,255,0.5)] hover:bg-[#2d5be0] transition-colors"
                        >
                            <WhatsAppIcon className="w-6 h-6" />
                            Testar no WhatsApp →
                        </motion.a>
                        <motion.a
                            data-testid="final-cta-call"
                            href={TEL_LINK}
                            whileHover={{ scale: 1.04 }}
                            whileTap={{ scale: 0.98 }}
                            className="inline-flex items-center justify-center gap-3 rounded-full border border-[#3B6FFF]/40 bg-[#121218] px-8 py-4 text-lg font-bold text-[#F5F5F5] hover:border-[#3B6FFF] transition-colors"
                        >
                            <Phone className="w-6 h-6" />
                            Ligar agora →
                        </motion.a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default FinalCTA;
